import NavMenuItem from './NavMenuItem';

export default NavMenuItem;
